export { default as CornerImage } from "./CornerImage";
export type { CornerImageProps } from "./types";
